// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"239":"19db878e","285":"19db878e","349":"19db878e","546":"1ec57414","759":"19db878e","821":"90ac8226"}[chunkId] + ".chunk.css";
};